import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import LayoutGap from "%/dynamic-component-editor/options/layout-gap";
import HorizontalLayoutAlign from "%/dynamic-component-editor/options/horizontal-layout-align";
import HorizontalLayoutVerticalAlign from "%/dynamic-component-editor/options/horizontal-layout-vertical-align";
import LayoutDirection from "%/dynamic-component-editor/options/layout-direction";
import Overflow from "%/dynamic-component-editor/options/overflow";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import MaxWidth from "%/dynamic-component-editor/options/max-width";
import MaxHeight from "%/dynamic-component-editor/options/max-height";
import MinHeight from "%/dynamic-component-editor/options/min-height";
import MinWidth from "%/dynamic-component-editor/options/min-width";
import LayoutWrap from "%/dynamic-component-editor/options/layout-wrap";
import ScaleWidthAnchor from "%/dynamic-component-editor/options/scale-width-anchor";

export default class HorizontalLayoutPositionOptions extends BaseOptionsBundle {
  optionTitle = "Layout";
  inspectorToolGroup = "layout";
  useInspectorLabel = false;
  static optionClassName = "i-dynamic-horizontal-layout-position";
  static userInterfaceComponent = {
    component: inspectorTools.HORIZONTAL_POSITION_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      LayoutWidth,
      LayoutHeight,
      MaxWidth,
      MaxHeight,
      MinHeight,
      MinWidth,
      LayoutDirection,
      Overflow,
      HorizontalLayoutAlign,
      HorizontalLayoutVerticalAlign,
      LayoutGap,
      new LayoutWrap({
        default: "nowrap",
      }),
      ScaleWidthAnchor,
    ]);
  }
}
